// layout
import Layout from "@/layouts/Layout.vue";


// users list
import usersList from "@/views/admin/users/list.vue";
import userPreview from "@/views/admin/users/preview.vue";

// utils
import { UserPermissions } from "@/utils";

let adminRoute = {
  path: "/admin",
  component: Layout,
  name: "Администрация",
  redirect: "/admin/users",
  meta: {
    title: "Администрация",
    actions: [UserPermissions.ADMIN],
    icon: "mdi-cogs",
    divider: true
  },
  hidden: false,
  children: [
    {
      path: "/admin/users",
      name: "Потребители",
      component: usersList,
      meta: {
        title: "Потребители",
        actions: [UserPermissions.ADMIN],
        icon: 'mdi-account-supervisor'
      }
    },
    {
      path: "/admin/users/:id",
      name: "Преглед на потребител",
      component: userPreview,
      meta: {
        title: "Преглед на потребител",
        actions: [UserPermissions.ADMIN],
        icon: 'mdi-account'
      },
      hidden: true
    }
  ]
}

export default adminRoute;